import { Injectable } from '@angular/core';
import { ConfirmationService, Message, MessageService } from 'primeng/api';
import { BehaviorSubject, forkJoin, retry, Subject, switchMap, throwError, timer } from 'rxjs';
import { ChangeControlLibraryConstants } from '../constants/changeControlLibraryConstants';
import { ChangeControlDetails } from '../models/change-control-details';
import { ChangeControlService } from './changecontrol.service';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { LinkedDocument } from '../../../shared/models/linked-documents';
import { ChangeControlUserAssignmentType } from '../models/change-control-user-assignment-type';
import { AssignmentGroupSharedDataService } from '../../../shared/services/assignment-group-shared-data.service';
import { ChangeControlAttachmentDetails } from '../../change-control-details/models/change-control-attachment-details';
import { ChangeControlDisplayDetails } from '../../change-control-details/models/change-control-display-details';
import { ChangeControlPersistenceService } from '../../change-control-details/services/change-control-persistence.service';

@Injectable({
  providedIn: 'root',
})
export class ChangecontrolPersistenceService {
  closeAndResetChangeControlSlider$ = new Subject<boolean>();
  changeManagementDetails$ = new BehaviorSubject<ChangeControlDetails | null>(null);
  changeManagementDisplayDetails$ = new BehaviorSubject<ChangeControlDisplayDetails | null>(null);
  changeManagementToUpdate!:ChangeControlDetails|null;
  isChangeControlEditSlider = false;
  currentTabInSliderMenu$ = new Subject<number>();
  currentTabInSliderMenuByCustomChange$ = new Subject<number>();
  errorTabIndices: number[] = [];
  navigateToErrorTabOnSave$ = new Subject<number>();
  populateErrorsForTab$ = new BehaviorSubject<boolean>(false);
    linkedDocuments: LinkedDocument[] = []
    changeControlAttachments: File[] = [];
    changeControlSaveInProgress$ = new BehaviorSubject<boolean>(false);
    changeControlSaveInProgressForSlider$ = new BehaviorSubject<boolean>(false);
    savedChangeControlAttachments: ChangeControlAttachmentDetails[] = [];
    deletedChangeControlAttachments: ChangeControlAttachmentDetails[] = [];
    filesToSave: ChangeControlAttachmentDetails[] = [];
    changeControlNumber: string = '';
    filesToDelete: string[] = [];
    uploadResponses: any = [];
    actionItemFilesResponses: any = [];
  dataReload$ = new BehaviorSubject<boolean>(false);
  validatedUsersList:any=[];
  usersList:any=[];
  reasonForChangeControlUpdate:string|null=null;
  changeControlId! : string;
  public toastMessage$ = new Subject<Message>();

  constructor(private confirmationService: ConfirmationService,
     private changeControlService: ChangeControlService,
     private router: Router,
     private messageService: MessageService,
     private assignmentGroupSharedDataService: AssignmentGroupSharedDataService,
     private changeControlPersistenceService:ChangeControlPersistenceService

    ) {}


  onTabChange = (tabIndex: number) => {
    this.currentTabInSliderMenu$.next(tabIndex);
  }
  onCustomTabChange = (tabIndex: number) => {
    this.currentTabInSliderMenuByCustomChange$.next(tabIndex);
  }  

  updateRelatedDocuments = (linkedDocuments :LinkedDocument[]) => {
    this.linkedDocuments = linkedDocuments;
  }

    // To Update Error Indices On Tab Changes By Tab Menu Or Using Next/Previous Button
    updateTabErrorIndex = (tabIndex: number, isError: boolean) => {
      isError ? this.addErrorTabIndex(tabIndex) : this.removeErrorTabIndex(tabIndex);
      this.populateErrorsForTab$.next(true);
    }
  
    // To Add Error Index On Tab Changes By Tab Menu Or Using Next/Previous Button
    addErrorTabIndex = (tabIndex: number) => {
      if (this.errorTabIndices.indexOf(tabIndex) === -1) {
        this.errorTabIndices.push(tabIndex);
      }
    }
  
    // To Remove Error Index On Tab Changes By Tab Menu Or Using Next/Previous Button
    removeErrorTabIndex = (tabIndex: number) => {
      if (this.errorTabIndices.indexOf(tabIndex) > -1) {
        this.errorTabIndices.splice(this.errorTabIndices.indexOf(tabIndex), 1);
      }
    }
  openConfirmationDialog = () => {
    this.confirmationService.confirm({
      message:
      ChangeControlLibraryConstants.ChangeControl_Slider_Confirmation_Text,
      header:
      ChangeControlLibraryConstants.ChangeControl_Slider_Confirmation_Header,
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.closeAndResetChangeControlSlider$.next(true);
      },
    });
  };

  updateChangeManagementDetails = (changeControlDetails: ChangeControlDetails) => {
    var targetCompletionDate= new Date(Date.UTC(
      new Date(changeControlDetails.targetCompletionDate).getFullYear(),
      new Date(changeControlDetails.targetCompletionDate).getMonth(),
      new Date(changeControlDetails.targetCompletionDate).getDate()
    ));
    changeControlDetails.targetCompletionDate= targetCompletionDate;
    this.changeManagementDetails$.next(changeControlDetails);
  }

  saveChangeManagement = (): void => {
    if (this.errorTabIndices.length === 0) {
      this.updateChangeControlSaveForSlider(true);
    let changeManagementToSave = this.changeManagementDetails$.getValue();
    let successMessage = `${ChangeControlLibraryConstants.ChangeControl_Created_Success}`;
    if (!!changeManagementToSave) { 
      changeManagementToSave.targetCompletionDate = new Date(changeManagementToSave.targetCompletionDate); 
      if(this.linkedDocuments.length > 0){
        changeManagementToSave.relatedDocuments = this.linkedDocuments.map((document) => document.number);
      }
       changeManagementToSave.reasonForChange=null;
       const attachmentsToSave = [...this.changeControlAttachments]; 
        this.changeControlService.addChangeControl(changeManagementToSave)
        .pipe(
                switchMap((changeControl) =>
                {
                  this.changeControlId = changeControl.id;
                  return this.changeControlService.getChangeControlById(this.changeControlId)
                  .pipe(
                    retry({
                      count: 5,
                      delay: (error, retryCount) => {
                        if (retryCount >= 5) {
                          return throwError(() => error); 
                        }
                        return timer(3000); // wait 3 seconds before retrying
                      }
                    })
                  );
                })
              )
        .subscribe({
          next: (response:any) => { 
            this.closeAndResetChangeControlSlider$.next(true);
            this.updateChangeControlSaveForSlider(false);
              this.changeControlNumber = response.number;
              changeManagementToSave!.number = response.number;
              if(attachmentsToSave.length > 0){
                this.saveFiles(successMessage, changeManagementToSave!,attachmentsToSave);
              }
              else{
                this.showConfirmationMessage(ChangeControlLibraryConstants.Severity_Success,
                  `${successMessage} ${response.number}`);
              this.openChangeManagementDetails(response.number);
              }
          },
          error: (error:any) => {
           this.updateChangeControlSaveForSlider(false);
             this.showConfirmationMessage(ChangeControlLibraryConstants.Severity_Err,
                  ChangeControlLibraryConstants.ChangeControl_Creation_Failed, true);
          },
        });
    }
    else{
      this.navigateToErrorTabOnSave$.next(this.errorTabIndices[0]);
    }
    }
  }

  updateChangeManagement = (): void => {
    let successMessage = `${ChangeControlLibraryConstants.ChangeControl_Updated_Success}`;
    if (this.errorTabIndices.length === 0) {
      let changeManagementToUpdate = this.changeManagementDetails$.getValue();
      if (!!changeManagementToUpdate) { 
        changeManagementToUpdate.reasonForChange= this.reasonForChangeControlUpdate;
        changeManagementToUpdate.targetCompletionDate = new Date(changeManagementToUpdate.targetCompletionDate); 
        changeManagementToUpdate.relatedDocuments = this.linkedDocuments != null? this.linkedDocuments.map((document)=>document.number) : [];   
        changeManagementToUpdate.attachments =this.savedChangeControlAttachments.filter(a=>!this.deletedChangeControlAttachments?.some((b=>a.fileId == b.fileId)));
        this.changeControlService.updateChangeControl(changeManagementToUpdate).subscribe({
          next: (response:any) => {
            // Info: On attachment delete - this toaster message is getting triggered
            if(this.changeControlAttachments.length > 0){
              this.saveFiles(successMessage, changeManagementToUpdate!, this.changeControlAttachments);
            }
            else{
              this.showConfirmationMessage(ChangeControlLibraryConstants.Severity_Success, `${successMessage} ${response.number}`);
            this.closeAndResetChangeControlSlider$.next(true);
            this.dataReload$.next(true);
            this.changeControlPersistenceService.updateChangeControlView();
            if(response?.eQMSScopes !== null && response?.eQMSScopes !== undefined){
              this.changeControlPersistenceService.selectedScopes.next(response?.eQMSScopes);
            }
          }},
          error: (error:any) => {
            console.error('Error while updating change control:', error);
          },
        });
      }
    }
    else{
      this.navigateToErrorTabOnSave$.next(this.errorTabIndices[0]);
    }
  }

  updateAssignment(fieldName: string, changeControlForm: FormGroup, userList : any[], assignmentGroups: any): void {
    const formValues = changeControlForm.getRawValue();
    const updatedAssignment =
      this.assignmentGroupSharedDataService.updateUserToAssignmentTypeArray(
        userList,
        formValues[fieldName],
        assignmentGroups,
        []
      );
    changeControlForm.patchValue({
      [fieldName]: updatedAssignment,
    });
  }

  updateChangeControlUserAssignment(fieldName:string, changeControlForm: FormGroup, userList : any[]):void{
    const changeControlUserAssignmentDto : ChangeControlUserAssignmentType[]=[]
    const formValues = changeControlForm.getRawValue();
    const users = formValues[fieldName];
    users.forEach((user : string) => {
      if (userList.some((obj:any) => obj.value === user)) {
          changeControlUserAssignmentDto.push({
            userAssignment:fieldName,
            name:user
          });
        }
      })
      changeControlForm.patchValue({
        [fieldName]: changeControlUserAssignmentDto,
      });
  }

  openChangeManagementDetails = (changeControlNumber: string) => {
    this.closeAndResetChangeControlSlider$.next(true);
    setTimeout(() => {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([ 
          '/eqms.changeControlDetails/' + changeControlNumber,
        ])
      );
      window.open(url, '_blank');
    }, 1000);
  }
  
  showConfirmationMessage = (severityMessage: string, summaryMessage: string, isSticky: boolean = false) => {
    this.toastMessage$.next({
      severity: severityMessage,
      summary: summaryMessage,
      sticky: isSticky
    });
  }

  checkSliderFromChangeControlDetails() {
    this.isChangeControlEditSlider = this.router.url.includes('eqms.changeControlDetails/');
  }

  enableDisableControls(
    formGroup: FormGroup,
    condition: boolean,
    controlNames: string[]
  ): void {
    controlNames.forEach((controlName) => {
      if (condition) {
        formGroup.get(controlName)!.enable();
      } else {
        formGroup.get(controlName)!.disable();
      }
    });
  }

  updateFileDetails = (changeControlAttachments: File[]) => {
    this.changeControlAttachments = changeControlAttachments;
  }


  saveFiles(successMessage: string,changeManagement?: ChangeControlDetails, attachments: File[] = []): Promise<void> {
    this.uploadResponses = [];
    this.actionItemFilesResponses = [];
    const files = attachments;
  
    const uploadPromises = files.map((file: File) => {
      return new Promise((resolve, reject) => {
        const modifiedFile = new File([file], changeManagement?.number + '/' + file.name, { type: file.type });
        this.changeControlService.uploadFile(modifiedFile, ChangeControlLibraryConstants.ChangeControl_Attachments_FolderName).subscribe(
          {
            next: (response: any) => {
              var fileToSave = this.constructChangeControlAttachment(response, file.name);
              this.filesToSave.push(fileToSave); // Add the file to the filesToSave array
              resolve(response); // Resolve the promise on success
            },
            error: () => {
              reject(new Error(ChangeControlLibraryConstants.File_Upload_Failed.replace(
                'Name', ChangeControlLibraryConstants.ChangeControlAttachments))); // Reject the promise on error
            }
          }
        );
      });
    });
  
    return Promise.all(uploadPromises)
      .then(() => {
        // All uploads succeeded
        this.saveOrUpdateChangeControl(changeManagement!, successMessage);
      })
      .catch(() => {
        // At least one upload failed
        const validationMessage = ChangeControlLibraryConstants.File_Upload_Failed.replace(
          'Name', ChangeControlLibraryConstants.ChangeControlAttachments
        );
        this.messageService.add({
          severity: ChangeControlLibraryConstants.Severity_Err,
          summary: validationMessage,
          sticky: true
        });
        this.saveOrUpdateChangeControl(changeManagement!, successMessage);
      });
  }
  


  saveOrUpdateChangeControl(changeManagement:ChangeControlDetails, successMessage: string){
    const filesAdded = this.deletedChangeControlAttachments.length > 0?         
    this.filesToSave.filter(a => !this.deletedChangeControlAttachments?.some(b => a.fileId === b.fileId)) : 
    this.filesToSave; 
    if(changeManagement.attachments == undefined) changeManagement.attachments = [];
    if(this.isChangeControlEditSlider){
      changeManagement.attachments = (changeManagement.attachments != null)? [...changeManagement.attachments, ...filesAdded] : changeManagement.attachments;
    }
    else{
      changeManagement.attachments = filesAdded;
    }
      this.changeControlService.updateChangeControl(changeManagement).subscribe({
        next: (response:any) => {
          if(this.isChangeControlEditSlider){
          this.closeAndResetChangeControlSlider$.next(true);
          this.dataReload$.next(true);
          this.changeControlPersistenceService.updateChangeControlView();
          // Info: on saving new File: toaster message getting triggered
          this.showConfirmationMessage(ChangeControlLibraryConstants.Severity_Success, `${successMessage} ${response.number}`);
          }
          else{
            this.showConfirmationMessage(ChangeControlLibraryConstants.Severity_Success,
              `${successMessage} ${response.number}`);
          this.openChangeManagementDetails(response.number);
          }
        },
        error: (error:any) => {
          console.error('Error while updating change control:', error);
        },
      });
  }

  constructChangeControlAttachment = ( fileSaveResponse: any, fileName : string): ChangeControlAttachmentDetails => {
    let responses :ChangeControlAttachmentDetails = {
        fileId: fileSaveResponse.fileId,
        attachmentName: fileName.split('.')[0],
        attachmentType: fileSaveResponse.fileExtension,
        attachmentPath: fileName
      }
    return responses;
  }

  

  chunkArray = (array: any, chunkSize: number) => {
    const numberOfChunks = Math.ceil(array.length / chunkSize)
   
    return [...Array(numberOfChunks)]
      .map((value, index) => {
        return array.slice(index * chunkSize, (index + 1) * chunkSize)
      })
  }



  openChangeControlDetails = (changeControlNumber: string) => {
    this.closeAndResetChangeControlSlider$.next(true);
    setTimeout(() => {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([ 
          '/eqms.changeControlDetails/' + changeControlNumber ,
        ])
      );
      window.open(url, '_blank');
    }, 1000);
  }
  updateSaveInProgressStatus = (status: boolean) => {
    this.changeControlSaveInProgress$.next(status);
  }
  updateChangeControlSaveForSlider(status: boolean) {
    this.changeControlSaveInProgressForSlider$.next(status);
  }
  updateSavedChangeControls = (documentAttachments: ChangeControlAttachmentDetails[]) => {
    this.savedChangeControlAttachments = documentAttachments;
  }
  updateDeletedAttachments = (documentAttachments: ChangeControlAttachmentDetails[]) => {
    this.deletedChangeControlAttachments = documentAttachments;
  }
}
